import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'

/**
 * The page canvas. Every band — including the footer — is a rounded rail
 * floating on the lavender background with one shared gutter.
 */
export function Layout() {
  const location = useLocation()

  return (
    <div className="min-h-dvh bg-canvas">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:inline-flex focus:min-h-[44px] focus:items-center focus:rounded-control focus:border focus:border-primary focus:bg-white focus:px-4 focus:text-[13px] focus:font-bold focus:text-ink"
      >
        Skip to content
      </a>

      <Header />

      <div className="flex flex-col gap-3 px-3 pb-3 sm:gap-5 sm:px-5 sm:pb-5">
        <main id="main" tabIndex={-1} className="flex flex-col gap-3 focus:outline-none sm:gap-5">
          {/* Keyed on the path so each route plays its own entrance. */}
          <div
            key={location.pathname}
            className="flex flex-col gap-3 motion-safe:animate-[rise-in_620ms_cubic-bezier(.19,1,.22,1)_both] sm:gap-5"
          >
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  )
}
